import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { apiFetch } from '../lib/api';

export default function TruckEdit() {
  const { token } = useParams();
  const [truck, setTruck] = useState(null);
  const [err, setErr] = useState('');
  const [saved, setSaved] = useState(false);
  const [form, setForm] = useState({ description: '', instagram: '', twitter: '', website: '' });

  useEffect(() => {
    apiFetch(`/api/truck/edit/${token}`)
      .then((t) => { setTruck(t); setForm({ description: t.description, instagram: t.instagram || '', twitter: t.twitter || '', website: t.website || '' }); })
      .catch((e) => setErr(e.message));
  }, [token]);

  const save = async (e) => {
    e.preventDefault();
    setSaved(false); setErr('');
    try {
      const updated = await apiFetch(`/api/truck/edit/${token}`, { method: 'PATCH', body: form });
      setTruck(updated);
      setSaved(true);
    } catch (ex) { setErr(ex.message); }
  };

  if (err) return <div className="min-h-screen flex items-center justify-center p-6"><div className="bg-white p-8 rounded-lg shadow text-center max-w-md"><h1 className="text-2xl font-bold mb-2">Link invalid</h1><p className="text-gray-600 mb-4">{err}</p><Link to="/" className="text-teal-600 hover:underline">Back to Culinera</Link></div></div>;
  if (!truck) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading…</div>;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      <main className="max-w-2xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">Edit your truck listing</h1>
        <p className="text-sm text-gray-600 mb-6">{truck.name} · {truck.city}</p>
        {saved && <div className="bg-green-50 border border-green-200 text-green-800 p-3 rounded mb-3 text-sm">✓ Changes saved.</div>}
        <form onSubmit={save} className="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Description</label>
            <textarea data-testid="edit-description" rows={4} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Instagram</label>
              <input data-testid="edit-ig" value={form.instagram} onChange={(e) => setForm({ ...form, instagram: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg" placeholder="yourhandle" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">X / Twitter</label>
              <input data-testid="edit-x" value={form.twitter} onChange={(e) => setForm({ ...form, twitter: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg" placeholder="yourhandle" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Website</label>
            <input data-testid="edit-website" type="url" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} className="w-full p-3 border border-gray-300 rounded-lg" placeholder="https://" />
          </div>
          <button data-testid="edit-save" type="submit" className="w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-teal-700">Save changes</button>
          <p className="text-xs text-gray-500 text-center">Keep this URL private. It's your permanent edit link.</p>
        </form>
      </main>
    </div>
  );
}
